'use strict';

$(() => {
    const $headerComp = $('.header-wrapper');
    if ($headerComp.hasClass('header-wrapper--with-transparency') || $headerComp.hasClass('header-wrapper--with-gradient')) {
        $('.full-bleed-banner__content-container').css('margin-top', $headerComp.height() + 'px');
    }

    $('.full-bleed-banner__description').each(function () {
        let $descriptionElement = $(this);
        let elementWidth = 0;
        if (app.window.width() >= 1279) {
            elementWidth = $descriptionElement.length ? $descriptionElement.attr('data-style-desktop-width') : 0;
        } else if (app.window.width() >= 767) {
            elementWidth = $descriptionElement.length ? $descriptionElement.attr('data-style-tablet-width') : 0;
        } else {
            elementWidth = $descriptionElement.length ? $descriptionElement.attr('data-style-mobile-width') : 0;
        }
        if (elementWidth) {
            $descriptionElement.css('width', elementWidth + 'px');
        }
    });

    $('.js-scroll-down').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $component = $button.closest('.full-bleed-banner');
        const offset = $component.offset();

        window.scrollTo({ top: offset.top + $component.height(), behavior: 'smooth' });
    });

    $(':has(.image-asset--link) .full-bleed-banner__content-wrapper ').on('click', (e) => {
        if ($(e.currentTarget).closest('.full-bleed-banner:not(.brand-chl)').length) {
            $(e.currentTarget).closest('.full-bleed-banner').find('.image-asset--link')[0].click();
        }
    });

    $('.full-bleed-banner__content-wrapper a').on('click', (e) => {
        e.stopPropagation();
    });
});
